import React, { useEffect } from "react"
import {
	useSizeCanvasToCssDimensions,
	StyledCanvas,
	drawBackground,
	clearCanvas
} from "./CanvasCommon"
import { useSettings, useEditor, useThumbnails } from "./Generator"

const BackgroundCanvas = () => {
	const { bgCanvasRef } = useEditor()
	const { values } = useSettings()
	const { selected } = useThumbnails()
	const bgColor = selected?.bgColor ?? values.bgColor
	useSizeCanvasToCssDimensions(bgCanvasRef)

	useEffect(() => {
		// clear canvas to remove previous image
		clearCanvas(bgCanvasRef.current)
		// draw background color
		drawBackground(bgCanvasRef.current, bgColor)
	}, [bgCanvasRef, bgColor])

	return <StyledCanvas ref={bgCanvasRef} />
}

export default BackgroundCanvas
